export const APP_SECTION = 'failed_payment_recovery';

export const APP_PAGE_NAMES = {
  failedPaymentRecovery: 'failed_payment_recovery_page',
  successfulPayment: 'successful_payment',
  unsuccessfulPayment: 'unsuccessful_payment'
};

export const CLICKSTREAM_EVENTS = {
  payWithKlarna: {
    elementName: 'pay_with_klarna',
    elementText: 'Pay with Klarna',
    appPageName: APP_PAGE_NAMES.failedPaymentRecovery,
    appSection: APP_SECTION
  },
  payWithRecurly: {
    elementName: 'pay_with_recurly',
    elementText: 'Pay with another method',
    appPageName: APP_PAGE_NAMES.failedPaymentRecovery,
    appSection: APP_SECTION
  },
  payRemainingInvoiceOnSuccess: {
    elementName: 'pay_remaining_invoice',
    elementText: 'Pay remaining invoice(s)',
    appPageName: APP_PAGE_NAMES.successfulPayment,
    appSection: APP_SECTION
  },
  dashboardCta: {
    elementName: 'dashboard_cta',
    elementText: 'Go to dashboard',
    appPageName: APP_PAGE_NAMES.successfulPayment,
    appSection: APP_SECTION
  },
  payRemainingInvoiceOnFailure: {
    elementName: 'pay_remaining_invoice',
    elementText: 'Pay remaining invoice(s)',
    appPageName: APP_PAGE_NAMES.unsuccessfulPayment,
    appSection: APP_SECTION
  }
};
